import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url, { brandName, countryCode, search }) => {
  const response = await AxiosConfig.create('put', '/quote/product')
    .call({
      brandName,
      countryCode,
      search,
    })
    .getResponseData();
  return response;
};

const useGetQuoteProducts = ({ brandName, countryCode, search }) => {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    brandName && countryCode
      ? ['quoteProducts', brandName, countryCode, search]
      : null,
    (key) => fetcher('/quote/product', { brandName, countryCode, search }),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    productList: data?.productList,
    productCount: data?.productCount,
    page: data?.page,
    nextPage: data?.nextPage,
    previousPage: data?.previousPage,
    isLoading,
    isError: !!error,
    error,
    isValidating,
    mutate,
  };
};

export default useGetQuoteProducts;
